export default __webpack_public_path__ + "4ea975512c0055a458c68afcd44455ee.woff";